import React from 'react';
import { connect } from 'react-redux';
import { Input, FormGroup, Label } from 'reactstrap';
import { DropDownList } from '@progress/kendo-react-dropdowns';

import {
    setUserInfo,
    checkEmailCall,
    changeView,
    setAlert
} from '../../../../../../Redux/Actions/Admin/ManagePurchaseAndRenewalsActions';

import { getCounties, setCounties } from '../../../../../../Redux/Actions/Admin/ManageDistrictActions';
import { fetchMembershipPackages } from '../../../../../../Redux/Actions/EndUser/MembershipAction';

import { fetchStates } from '../../../../../../Redux/Actions/CommonActions';

import IsLoading from '../../../../../Shared/Loading/IsLoading';

import axios from 'axios';
import { ROOT_API_URL } from '../../../../../../api-config';
import _ from 'lodash';
import { Alert } from 'reactstrap';
import { auth } from '../../../../../../services';

import PlacesAutocomplete, {
    geocodeByAddress,
    geocodeByPlaceId,
    getLatLng,
} from 'react-places-autocomplete';

const initialState = {
    view: "CheckUser",
    membershipLookupEmail: "",
    membershipData: [],
    address1: "",
    address2: "",
    applicationUser: {},
    city: "",
    email: "",
    firstName: "",
    lastName: "",
    phone: "",
    state: {
        id: 0,
        name: ''
    },
    countyObj: { countyId: 0, countyName: "" },
    county: "",
    zip: "",
    isLoading: false,
    touched: {
        firstName: false,
        lastName: false,
        address1: false,
        address2: false,
        city: false,
        state: false,
        county: false,
        zip: false,
        phone: false,
        email: false,
    },
};

class CheckUser extends React.Component {
    constructor(props) {
        super(props);
        this.state = initialState;
        this.delayedCallback = _.debounce(this.checkEmailCall, 2000);
        this.onEmailChange = this.onEmailChange.bind(this);
    }

    componentDidMount() {
        this.props.fetchStates();
    }

    checkEmailCall = () => {
        this.setState({ isLoading: true })
        const options = { method: 'POST', headers: auth.authHeader() };
        axios.get(`${ROOT_API_URL}/ManageTransaction/SearchMembership?searchTerm=${this.state.membershipLookupEmail}`, options)
            .then((response) => {
                if (response.data.length > 0) {
                    console.log(response.data);
                    this.setState({
                        membershipData: response.data,
                        isLoading: false
                    },
                        () => {
                            this.props.setAlert(true, "Users Found", 'success')
                        }
                    );
                    setTimeout(() => {
                        this.props.setAlert(false, "");
                    }, 5000)
                } else if (response.data.length === 0) {
                    this.setState({
                        ...initialState,
                        membershipLookupEmail: this.state.membershipLookupEmail,
                        membershipData: response.data,
                        isLoading: false
                    },
                        () => this.props.setAlert(true, "No Memberships for Users Found", 'danger')
                    );
                    setTimeout(() => {
                        this.props.setAlert(false, "");
                    }, 5000)
                } else {
                    this.setState({
                        ...initialState,
                        membershipLookupEmail: this.state.membershipLookupEmail,
                        isLoading: false
                    },
                        () => this.props.setAlert(true, response.data.message, 'danger')
                    );
                    setTimeout(() => {
                        this.props.setAlert(false, "");
                    }, 5000)
                }
            })
            .catch((response) => {
                this.setState({ isLoading: false }, () => this.props.setAlert(true, response.message, 'danger'))
            });
    }

    onEmailChange = (event) => {
        var userId = '';
        if (auth.isAuthenticated()) {
            userId = auth.getAuthUserId()
        }
        this.setState(
            {
                membershipLookupEmail: event.target.value

            },
            () => {
                this.delayedCallback();
            }

        );
    };

    handleChange = ({ target }) => {
        this.setState({ [target.name]: target.value });
    };

    handleAutoAddressChange = address => {
        this.setState({ address });
    };

    handleAutoSelect = (address) => {
        this.props.getCounties(this.state.state.id);
        this.setState({ address });
        this.setAutofillFields(address, this.props.district.counties);
    };

    handleState = (event) => {
        this.props.getCounties(event.target.value.id);
        const value = event.target.value;
        if (value !== null) {
            this.setState({ state: value });
        }
    };

    selectCountyInDD = (event) => {
        this.setState({
            countyObj: event.target.value
        })
    }

    formatPhone = (val) => {
        if (!val) return val;
        var x = val.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        return !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    }

    setAllTouchedTrue() {
        this.setState({
            touched: {
                firstName: true,
                lastName: true,
                address1: true,
                address2: true,
                city: true,
                state: true,
                zip: true,
                phone: true,
                email: true,
                county: true,
            }
        })
    }

    handleBlur = (field) => (evt) => {
        this.setState({
            touched: { ...this.state.touched, [field]: true },
        });
    }

    isModelValid() {
        return this.state.address1 !== "" &&
            this.state.city !== "" &&
            this.state.zip !== "" &&
            this.state.phone !== "" &&
            this.state.firstName !== "" &&
            this.state.lastName !== "" &&
            this.state.email !== "" &&
            this.state.countyObj.countyName !== "";
    }

    handleSubmit = (event) => {
        event.preventDefault();
        if (this.isModelValid()) {
            this.props.setUserInfo(this.state);
            this.props.changeView({ view: 'AddItems' })
        } else {
            this.setAllTouchedTrue();
        }
    }

    handlePhoneChange = (event) => {
        event.target.value = this.formatPhone(event.target.value);
        this.setState({
            [event.target.name]: event.target.value || ''
        });
    }

    handleMembershipSelectChange = (event) => {
        if (event.target.value !== null) {

            if (event.target.value.membershipType != null) {
                this.props.fetchMembershipPackages(event.target.value.membershipType.membershipTypeID);
            }

            this.setState({
                firstName: event.target.value.firstName,
                lastName: event.target.value.lastName,
                email: event.target.value.email,
                address1: event.target.value.mailingAddress1,
                address2: event.target.value.mailingAddress2,
                city: event.target.value.mailingCity,
                zip: event.target.value.mailingZip,
                mailingStateId: event.target.value.state.id,
                state: event.target.value.state,
                countyObj: event.target.value.countyObj || { countyId: 0, countyName: "" },
                county: event.target.value.countyObj ? event.target.value.countyObj.countyId : 0,
                phone: event.target.value.phone || '',
                membershipId: event.target.value.membershipId,
                userId:event.target.value.userID
            });

            this.props.getCounties(event.target.value.state.id);
        }
    }

    fetchCountiesByStateId = async (id) => {
        return await axios.get(`${ROOT_API_URL}/ManageDistrict/GetCounties?stateId=${id}`).then((response) => {
            this.props.setCounties(response.data);
        });
    }

    setCountyAsync = async (stateId, county) => {
        await this.fetchCountiesByStateId(stateId);

        var countyLst = this.props.district.counties;
        countyLst.forEach(countyObj => {
            if (county.includes(countyObj.countyName)) {
                this.setState({
                    countyObj: countyObj
                })
            }
        });
    }

    SetTopSuggestion = suggestions => {

        if (!_.isEqual(this.state.TopSuggestion, suggestions[0])) {
            this.setState({ TopSuggestion: suggestions[0] })
            this.setAutofillFields(suggestions[0].description);
        }
    }

    setAutofillFields = (address, countiesList) => {

        geocodeByAddress(address)
            .then(results => {

                results.map((addressResults) => {
                    var mailingInformation = {
                        address1: "",
                        city: "",
                        state: {
                            id: 0,
                            name: ''
                        },
                        countyObj: { countyId: 0, countyName: "" },
                        zip: ""
                    }
                    addressResults.address_components.map((result) => {
                        if (result.types.includes("street_number")) {
                            mailingInformation.address1 = result["short_name"];
                        }
                        if (result.types.includes("route")) {
                            mailingInformation.address1 = mailingInformation.address1 + " " + result["short_name"];
                        }
                        if (result.types.includes("locality")) {
                            mailingInformation.city = result["short_name"];
                        }
                        if (result.types.includes("administrative_area_level_1")) {
                            //mailingInformation.state = result["short_name"];
                            var stateObj = this.props.common.states.find((stateObj) => {
                                if (stateObj.name === result["short_name"].toString()) {
                                    return stateObj
                                }
                            });

                            if (stateObj) {

                                mailingInformation.state = stateObj;

                            }

                        }
                        if (result.types.includes("administrative_area_level_2")) {
                            mailingInformation.county = result["long_name"];
                        }
                        if (result.types.includes("postal_code")) {
                            mailingInformation.zip = result["short_name"];
                        }
                    });

                    //this.props.getCounties(mailingInformation.StateObject.id);
                    this.setState(mailingInformation);

                })

            }).then(() => {
                //this.selectCounty(this.state.County);
                this.setCountyAsync(this.state.state.id, this.state.county);
            });
    }
    render() {
        return (
            <div className="">
                <FormGroup>
                    <div className="row">
                        <div className="col-md-12">
                            <label htmlFor="exampleEmail" className="label-header">Membership Lookup: </label>
                            <Input name="membershipLookupEmail" id="membershipLookupEmail" value={this.state.membershipLookupEmail}
                                onChange={this.onEmailChange}
                                type="text"
                                placeholder="Please enter member ID, email, name, or org name." />
                        </div>
                    </div>
                    {this.state.membershipData.length > 0 ?
                        <div className="row">
                            <div className="form-group col-md-12">
                                <label htmlFor="subscriptionId">Please Select Member</label>
                                <DropDownList data={this.state.membershipData}
                                    textField="fullConcatinatedMembershipString"
                                    dataItemKey="membershipId"
                                    onChange={this.handleMembershipSelectChange}
                                    value={this.state.selectedMember}
                                    allowCustom={false}
                                    filterable={false}
                                    clearButton={false}
                                    width={300}
                                    required={true}
                                />
                            </div>
                        </div> : ""
                    }
                </FormGroup>
                {
                    this.props.purchaseAndRenewals.purchaseLoading ? (
                        <IsLoading message="Loading User Information" />
                    ) : (
                        <form>

                            <Alert
                                color={this.props.purchaseAndRenewals.color}
                                isOpen={this.props.purchaseAndRenewals.visible}
                                style={{ position: 'fixed', width: '100%', height: '50px', zIndex: '1', top: '2px', left: '0' }}
                            >
                                {this.props.purchaseAndRenewals.message}
                            </Alert>
                            {this.props.purchaseAndRenewals.userInfo ? <h1>Please look over info</h1> : <h1>Please enter new user info</h1>}
                            <div className="row">
                                <div className="form-group col-md-6">
                                    <label htmlFor="firstName" className={this.state.touched.firstName && this.state.firstName === '' ? "error" : ""}>First Name</label>
                                    <Input
                                        id="firstName"
                                        type="text"
                                        value={this.state.firstName || ""}
                                        onChange={this.handleChange}
                                        name="firstName"
                                        invalid={this.state.touched.firstName && this.state.firstName === '' ? true : false}
                                        onBlur={this.handleBlur('firstName')}
                                    />
                                </div>
                                <div className="form-group col-md-6">
                                    <label htmlFor="lastName" className={this.state.touched.lastName && this.state.lastName === '' ? 'error' : ''}>Last Name</label>
                                    <Input
                                        id="lastName"
                                        type="text"
                                        value={this.state.lastName || ""}
                                        onChange={this.handleChange}
                                        name="lastName"
                                        invalid={this.state.touched.lastName && this.state.lastName === '' ? true : false}
                                        onBlur={this.handleBlur('lastName')}
                                    />
                                </div>
                            </div>
                            <label htmlFor="lookupAddrField">Lookup Address</label>
                            <PlacesAutocomplete
                                value={this.state.address || ""}
                                onChange={this.handleAutoAddressChange}
                                onSelect={this.handleAutoSelect}
                            >
                                {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                    <div className="col-md-12" id="lookupAddrField" style={ {padding: '0px', paddingBottom: '10px'}}>
                                        <input style={{ width: "100%" }}
                                            {...getInputProps({
                                                placeholder: 'Search Places...'
                                            })}
                                        />
                                        <div style={{ width: "100%" }}>
                                            {loading && <div><p>Loading...</p></div>}
                                            {suggestions.length > 0 ? this.SetTopSuggestion(suggestions)
                                                : ""}
                                            {suggestions.map(suggestion => {
                                                const className = suggestion.active
                                                    ? 'suggestion-item--active'
                                                    : 'suggestion-item';
                                                // inline style for demonstration purpose
                                                const style = suggestion.active
                                                    ? {
                                                        backgroundColor: '#f0f0f0',
                                                        cursor: 'pointer',
                                                        width: '100%'
                                                    }
                                                    : {
                                                        backgroundColor: '#ffffff',
                                                        cursor: 'pointer',
                                                        width: '100%'
                                                    };
                                                return (
                                                    <div
                                                        {...getSuggestionItemProps(suggestion, {
                                                            className,
                                                            style,
                                                        })}
                                                    >
                                                        <span>{suggestion.description}</span>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                )}
                            </PlacesAutocomplete>
                            <div className="row">
                                <div className="form-group col-md-6">
                                    <label htmlFor="address1" className="">Address 1</label>
                                    <Input
                                        id="address1"
                                        type="text"
                                        value={this.state.address1 || ""}
                                        onChange={this.handleChange}
                                        name="address1"
                                        invalid={this.state.touched.address1 && this.state.address1 === '' ? true : false}
                                        onBlur={this.handleBlur('address1')}
                                    />
                                </div>
                                <div className="form-group col-md-6">
                                    <label htmlFor="address2" className="">Address 2</label>
                                    <Input
                                        id="address2"
                                        type="text"
                                        value={this.state.address2 || ""}
                                        onChange={this.handleChange}
                                        name="address2"
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="form-group col-md-3">
                                    <label htmlFor="city" className="">City</label>
                                    <Input
                                        id="city"
                                        type="text"
                                        value={this.state.city || ""}
                                        onChange={this.handleChange}
                                        name="city"
                                        invalid={this.state.touched.city && this.state.city === '' ? true : false}
                                        onBlur={this.handleBlur('city')}
                                    />
                                </div>
                                <div className="form-group col-md-3">
                                    <label>State</label>
                                    <DropDownList data={this.props.common.states}
                                        id="State"
                                        name="state"
                                        textField="name"
                                        dataItemKey="id"
                                        onChange={this.handleState}
                                        value={this.state.state}
                                    />
                                </div>
                                {
                                    this.props.district.counties.length > 0 ?
                                        <div className="form-group col-md-3">
                                            <label htmlFor="County">County</label>
                                            <DropDownList data={this.props.district.counties}
                                                id="County"
                                                name="county"
                                                textField="countyName"
                                                dataItemKey="countyId"
                                                onChange={this.selectCountyInDD}
                                                value={this.state.countyObj}
                                                className={this.state.touched.county && this.state.countyObj.countyName === '' ? "error" : ""}
                                                onBlur={this.handleBlur('county')}
                                            />
                                        </div> 
                                    : ""
                                }
                                <div className="form-group col-md-3">
                                    <label htmlFor="zip" className="">Zip</label>
                                    <Input
                                        id="zip"
                                        vakudutystyles="false"
                                        value={this.state.zip}
                                        onChange={this.handleChange}
                                        name="zip"
                                        pattern="(\d{5}([\-]\d{4})?)"
                                        type="text"
                                        placeholder="12345"
                                        title="Zip Code (Format: 12345 or 12345-6789)"
                                        invalid={this.state.touched.zip && this.state.zip === '' ? true : false}
                                        onBlur={this.handleBlur('zip')}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="form-group col-md-6">
                                    <label htmlFor="phone" className="">Phone</label>
                                    <Input
                                        id="phone"
                                        type="text"
                                        value={this.state.phone}
                                        vakudutystyles="false"
                                        onChange={this.handlePhoneChange}
                                        name="phone"
                                        pattern="[\(]\d{3}[\)] \d{3}[\-]\d{4}"
                                        title="Phone Number (Format: (123) 456-7890)"
                                        placeholder="(123) 456-7890"
                                        onBlur={this.handleBlur('phone')}
                                        invalid={this.state.touched.phone && !this.state.phone && this.handlePhoneChange ? true : false}
                                    />
                                </div>
                                <div className="form-group col-md-6">
                                    <label htmlFor="email" className="">Email</label>
                                    <Input
                                        id="email"
                                        type="text"
                                        value={this.state.email || ""}
                                        onChange={this.handleChange}
                                        name="email"
                                        invalid={this.state.touched.email && this.state.email === '' ? true : false}
                                        onBlur={this.handleBlur('email')}
                                    />
                                </div>
                            </div>
                            <button className="submitBtn" onClick={this.handleSubmit}>Start</button>
                        </form>
                    )}
                </div>
            )
    }
}



function mapStateToProps(state) {
    return {
        purchaseAndRenewals: state.purchaseAndRenewals,
        common: state.common,
        district: state.district,
        membership: state.membership
    };
}

export default connect(mapStateToProps, {
    setUserInfo,
    checkEmailCall,
    changeView,
    fetchStates,
    getCounties,
    setCounties,
    fetchMembershipPackages,
    setAlert
})(CheckUser);